export const getRoundClientId = () => {
    const PROD_ROUND_CLIENT_ID = 5;
    const testClientId = localStorage.getItem('round_payment_request_test_client_id');

    if (testClientId) {
        return parseInt(testClientId);
    }

    return PROD_ROUND_CLIENT_ID;
};
